import { AES, enc } from 'crypto-js'

const secretKey = 'autoevaluacion'
const key = '__au__'

export function encrypt(text) {
  return AES.encrypt(text, secretKey).toString()
}

export function decrypt(textEncrypted) {
  const bytes = AES.decrypt(textEncrypted, secretKey)
  const originalText = bytes.toString(enc.Utf8)
  return originalText
}

export function getUserEncryptedLocalStorage() {
  return JSON.parse(window.localStorage.getItem(key))
}

export function setUserEncryptedLocalStorage(username, password) {
  const userEncrypted = [encrypt(username), encrypt(password)]
  window.localStorage.setItem(key, JSON.stringify(userEncrypted))
}

export function removeUserEncryptedLocalStorage() {
  window.localStorage.removeItem(key)
}
